import { styled, css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

export const Wrapper = styled.div<{ $hasError: boolean; $hasSelection?: boolean }>`
  ${({ theme: { colors, fontSizes, borderRadius }, $hasError, $hasSelection }) => css`
    align-items: center;
    background: ${colors.brandDarkAlpha5};
    border-radius: ${borderRadius.sm};
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    outline: 1px solid ${$hasError ? colors.semanticDanger : 'transparent'};
    padding: ${$hasSelection ? '0.25rem 0.5rem 0.25rem 0.5rem' : '0.438rem 0.5rem 0.438rem 1rem'};
    min-height: 2.5rem;
    width: 100%;
    box-sizing: border-box;
    font-size: ${fontSizes.s16};
    transition: outline-color 120ms ease-in-out;

    &:focus-within {
      outline-color: ${$hasError ? colors.semanticDanger : colors.brandPrimary};
    }

    input {
      background: transparent;
      border: 0;
      color: ${colors.brandDark};
      flex: 1 1 1rem;
      font-size: inherit;
      height: 1.5rem;
      line-height: 1.5rem;
      margin: 0;
      min-inline-size: 0;
      min-width: 1rem;
      outline: none;
      padding: 0;
      width: auto;

      &::placeholder {
        color: ${colors.brandDarkTint50};
      }
    }
  `}
`;

export const Chip = styled.span`
  ${({ theme: { colors, borderRadius, fontSizes } }) => css`
    align-items: center;
    background: ${colors.brandDarkTint90};
    border-radius: ${borderRadius.sm};
    display: flex;
    font-size: ${fontSizes.s12};
    gap: 0.5rem;
    padding: 0.25rem 0.375rem 0.25rem 0.438rem;
    user-select: none;
    z-index: 1;

    .button {
      flex-shrink: 0;
      aspect-ratio: 1 / 1;
      height: 1rem;
      min-width: unset;
      width: 1rem;
      box-shadow: none;
      padding: 0;

      .icon {
        height: 1rem;
        width: 1rem;
        path {
          stroke: ${colors.brandDark};
          stroke-width: 1.5;
        }
      }
    }

    &:focus {
      outline-color: ${colors.brandDark};
      outline-offset: 2px;
      outline-width: 1px;
    }
  `}
`;

export const ChipValue = styled.span`
  ${({ theme: { colors } }) => css`
    color: ${colors.brandDark};
    display: -webkit-box;
    line-height: 1.2;
    overflow: hidden;
    max-width: 15rem;
    font-size: inherit;
    text-align: left;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  `}
`;

export const Footer = styled.div`
  ${({ theme: { fontSizes, colors } }) => css`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    margin-top: 0.5rem;

    .error {
      color: ${colors.semanticDanger};
      font-size: ${fontSizes.s12};
      line-height: 1.2;
    }

    footer {
      font-size: ${fontSizes.s12};
      color: ${colors.brandDarkTint70};
    }
  `}
`;
